module.exports = __webpack_public_path__ + "public/images/header-slide-7.cfed20ea3a265dae98076d9e8e24043e.jpeg";